import { makeSelectors } from '@utils/css';

const printerSelectors = makeSelectors({
  container: "printer--container",
  throbber: "printer--throbber"
});

export { printerSelectors };
//# sourceMappingURL=selectors.js.map
